import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LinkedInWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 39 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          d="M24.114 7.519H11.886a4.368 4.368 0 0 0-4.367 4.367v12.228a4.368 4.368 0 0 0 4.367 4.367h12.228a4.367 4.367 0 0 0 4.367-4.367V11.886a4.367 4.367 0 0 0-4.367-4.367Zm-9.608 16.595h-2.62v-9.608h2.62v9.608Zm-1.31-10.716c-.844 0-1.529-.69-1.529-1.54 0-.85.685-1.541 1.529-1.541.844 0 1.528.69 1.528 1.54 0 .852-.684 1.542-1.528 1.542Zm11.791 10.716h-2.62v-4.895c0-2.942-3.494-2.719-3.494 0v4.895h-2.62v-9.608h2.62v1.542c1.22-2.259 6.114-2.426 6.114 2.162v5.904Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_112933" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_112933" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
